import {Button, Card, Col, Divider, Input, message, Modal, Row, Table, Tabs, Tag, Typography} from "antd";
import React, {useMemo, useRef, useState} from "react";
import {
    AllBaseInfoListResponse,
    getCurrentMSeconds,
    InitSafetyCheckOfOperation,
    ListCondition,
    SafetyCheckOfOperation
} from "../Details/common";
import handleAxios, {fileDownLoad} from "../../../Http/request";
import {SearchOutlined} from "@ant-design/icons";
import {ColumnsType} from "antd/es/table";
import {
    AllBaseInfo,
    CheckAllBaseInfo,
    Consumables,
    EditOptions,
    FaceDiagnosis,
    InitConsumablesRecord,
    InitFaceDiagnosis,
    InitNursingRecord,
    InitPostoperativePrecautions,
    InitScarInjectionInformedConsentForm,
    InitSurgicalInformedConsentForm,
    NursingRecord,
    PostPrecautionForScarSurgery,
    ScarInjectionInformedConsentForm,
    SurgicalInformedConsentForm,
    TotalProfile,
    UpdateOneBaseInfo
} from "../common";
import {BasicDataResponse, SUBMIT_TYPE} from "../../../Http/common";
import SafetyCheck from "./SafetyCheck";
import NursingRecordOfOperation from "./NursingRecordOfOperation"
import Consumable from "./Consumable";
import BaseInfoEditor from "../../../componts/BaseInfoEditor";
import FaceDiagnosisPage from "./FaceDiagnosisPage";
import PostoperativePrecautionsForScarSurgeryPage from "./PostoperativePrecautionsForScarSurgeryPage";
import SurgicalInformedConsentPage from "./SurgicalInformedConsentPage";
import ScarInjectionInformedConsentPage from "./ScarInjectionInformedConsentPage";

const { Text, Link } = Typography

export default function () {
    // 消息提醒
    const [messageApi, contextHolder] = message.useMessage();

    const [options, setOptions] = useState<EditOptions>();
    // 基础信息编辑对话框
    const [editing, setEditing] = useState<AllBaseInfo | undefined>(undefined);

    const [timeStamp, setTimeStamp] = useState<number>(getCurrentMSeconds());
    /**
     * 获取一条记录的几张表格
     * @param record
     */
    async function getAllDraft(record: AllBaseInfo) {
        clearUseRefAndFresh();
        setLoading(true);
        await getSafetyCheckByProfileId(record);
        await getNursingRecordByProfileId(record);
        await getConsumableRecordByProfileId(record);
        await getFaceDiagnosisByProfileId(record); // 拉取疤痕面诊单
        await getSurgicalInformedConsentByProfileId(record);  // 拉取手术知情同意书草稿
        await getPostcautionForScarByProfileId(record); // 拉取疤痕手术术后注意事项
        await getScarInjectionInformedConsentByProfileId(record); // 获取疤痕注射知情同意书
        setTimeStamp(getCurrentMSeconds());
        setLoading(false)
    }

    /**
     * 拉取所有的配置选项
     */
    async function getAllConfigs () {
        let ret: Promise<BasicDataResponse<EditOptions>> = handleAxios.get("/api/getAllConfigs");
        ret.then((res) => {
            if (res.code === 0) {
                setOptions(res.data);
            } else {
                messageApi.open({
                    type:"error",
                    content: "拉取配置选项出错！"
                })
            }
        }).catch((error) => {
            // 只要发生异常，就返回重定向页面，大概率是session过期了
            messageApi.error("用户信息失效，请重新登陆");
            window.location.href="/login";
        })
    }

    // 查询条件
    const [listConditions, setListConditions] = useState<ListCondition>({
        limit: 10,
        offset: 0,
    })
    // 表头的所有列
    const tableHeader: ColumnsType<AllBaseInfo> = [
        {
            title:"序号",
            dataIndex:"id",
            key:"id",
            width: 100,
            sorter: (a, b) => a.id - b.id,
        },
        {
            title:"病案号",
            dataIndex: "profileId",
            width: 200,
            sorter:(a, b) => Number(a.profileId) - Number(b.profileId)
        },
        {
            title:"姓名",
            dataIndex: "name",
            width: 150,
        },
        {
            title:"生日",
            dataIndex: "birthday",
            width: 120
        },
        {
            title:"性别",
            dataIndex: "gender",
            // key:"gender",
            width: 120,
            onFilter: (value, record) => {
                return record.gender === value
            },
            sorter:(a, b) => a.gender.localeCompare(b.gender),
            filters: [
                {
                    text: "男",
                    value: "男",
                },
                {
                    text: "女",
                    value: "女"
                }
            ],
            render:(_, {gender}) => {
                if (gender == '男') {
                    return (
                        <Tag color="blue">
                            {gender}
                        </Tag>
                    )
                } else if (gender === '女') {
                    return (
                        <Tag color="magenta">
                            {gender}
                        </Tag>
                    )
                } else {
                    return (
                        <Tag >
                            空
                        </Tag>
                    )
                }
            }
        },
        {
            title: "修改人",
            key:"updateBy",
            dataIndex: "updateBy",
            width:80
        },
        {
            title: "修改时间",
            key: "updateAt",
            dataIndex: "updateAt",
            width: 200,
            sorter: (a, b) => {
                if (!a.updateAt && !b.updateAt) {
                    return 0;
                } else if (!a.updateAt) {
                    return -1;
                } else if (!b.updateAt) {
                    return 1
                } else {
                    let dataA = new Date(a.updateAt);
                    let dateB = new Date(b.updateAt);
                    if (dataA < dateB) {
                        return -1;
                    } else if (dataA === dateB) {
                        return 0;
                    } else {
                        return 1;
                    }
                }
            }
        },
        {
            title:"备注",
            dataIndex: "ext",
            width: 150,
            // key:"ext",
            ellipsis: true,
            render: (_, {ext}) =>
            {
                // 长度大于25字符的仅展示25字符
                let ret = "";
                if (ext === undefined) {
                    ret = "空"
                } else {
                    ret = ext;
                }
                return (
                    <>
                        {ret}
                    </>
                )
            }
        },
        {
            title: "操作",
            // width: 400,
            render: (index, record) => {
                return (
                    <>
                        <Button
                            style={{
                                marginLeft:"5px"
                            }}
                            type="link"
                            onClick={() => {
                                setEditing(record)
                            }}
                        >
                            修改基础信息
                        </Button>
                        <Button
                            style={{marginLeft:"5px"}}
                            type="link"
                            onClick={() => {
                                // 初始化空白表
                                safetyCheckInfo.current = InitSafetyCheckOfOperation(record);
                                nursingRecord.current = InitNursingRecord(record);
                                consumableRecord.current = InitConsumablesRecord(record);
                                faceDiagnosisRecord.current = InitFaceDiagnosis(record); // 根据基础信息初始化疤痕面诊单
                                postoperativePrecautionsForScarSurgeryRecord.current = InitPostoperativePrecautions(record);  // 根据基础信息初始化疤痕手术术后注意事项
                                surgicalInformedConsentFormRecord.current = InitSurgicalInformedConsentForm(record);
                                scarInjectionInformedConsentFormRecord.current = InitScarInjectionInformedConsentForm(record);
                                setCurrentBaseInfo(record);
                                // console.log("current safetyCheckOfOperation", safetyCheckInfo.current)
                                // console.log("current record:", record)
                                setTimeStamp(getCurrentMSeconds())
                            }}
                        >新建空白表</Button>
                        <Button
                            style={{marginLeft:"5px"}}
                            type="link"
                            onClick={async () => {
                                await getAllDraft(record);
                                setCurrentBaseInfo(record);
                                // faceDiagnosisRecord.current = InitFaceDiagnosis(record); // 根据基础信息初始化疤痕面诊单
                            }}
                        >加载历史/草稿</Button>
                    </>
                )
            }
        }
    ];
    const [loading, setLoading] = useState(true);

    // 拉病人的所有基础信息接口
    async function listProfiles () {
        setLoading(true);
        let ret: Promise<BasicDataResponse<AllBaseInfoListResponse>> = handleAxios.post("/api/listProfiles",
            listConditions);
        ret.then((res) => {
            if (res.code === 0) {
                setListResponse(res.data);
                setLoading(false);
            } else {
                messageApi.error("拉取失败")
            }
        }).catch((error) => {
            console.log("拉取失败！")
        })
    }

    // 处理搜索
    const handleSearch = () => {
        clearUseRefAndFresh();
        listProfiles();
    };

    /**
     * 存储所有的基础信息
     */
    const [listResponse, setListResponse] = useState<AllBaseInfoListResponse>()

    /**
     * 当前正在编辑的基础信息
     */
    const [currentBaseInfo, setCurrentBaseInfo] = useState<AllBaseInfo | undefined>(undefined);

    const safetyCheckInfo = useRef<SafetyCheckOfOperation | undefined>(undefined);

    // 手术护理记录单
    const nursingRecord = useRef<NursingRecord | undefined>(undefined);

    // 记录所用材料明细
    const consumableRecord = useRef<Consumables | undefined>(undefined);

    // 记录疤痕面诊单
    const faceDiagnosisRecord = useRef<FaceDiagnosis | undefined>(undefined);

    // 记录疤痕术后注意事项
    const postoperativePrecautionsForScarSurgeryRecord = useRef<PostPrecautionForScarSurgery |undefined> (undefined);

    // 记录手术知情同意书
    const surgicalInformedConsentFormRecord = useRef<SurgicalInformedConsentForm | undefined>(undefined);

    // 记录疤痕注射知情同意书
    const scarInjectionInformedConsentFormRecord = useRef<ScarInjectionInformedConsentForm| undefined>(undefined);

    // 控制当前默认激活的tab 的key
    const [currentActiveKey, setCurrentActiveKey] = useState<string>("0")

    // 清除所有useRef的值并刷新页面
    const clearUseRefAndFresh = () => {
        nursingRecord.current = undefined;
        consumableRecord.current = undefined;
        safetyCheckInfo.current = undefined;
        faceDiagnosisRecord.current = undefined;
        postoperativePrecautionsForScarSurgeryRecord.current = undefined;
        surgicalInformedConsentFormRecord.current = undefined;
        scarInjectionInformedConsentFormRecord.current = undefined;
    }

    /**
     * 存储所有草稿
     */
    const saveAllDraft = async () => {
        await saveSafetyCheckInfo(safetyCheckInfo.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT);
        await saveNursingRecord(nursingRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT);
        await saveConsumableRecord(consumableRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT);
        await saveFaceDiagnosisInfo(faceDiagnosisRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT); // 保存疤痕面诊单
        await saveSurgicalInformedConsentInfo(surgicalInformedConsentFormRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT); // 保存手术知情同意书
        await saveScarInjectionInformedConsentInfo(scarInjectionInformedConsentFormRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT) // 保存疤痕注射知情同意书
        await savePostcautionForScarInfo(postoperativePrecautionsForScarSurgeryRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT) // 保存疤痕手术术后注意事项
    }


    // 消耗明细变更
    const consumableOnChange = (v: Partial<Consumables>) => {
        let newConsumableRecord = {
            ...consumableRecord.current,
            ...v
        };
        // console.log(newConsumableRecord)
        consumableRecord.current = newConsumableRecord;
    }

    /**
     * 储存消耗明细表草稿
     * @param newDraft
     */
    async function saveConsumableRecord(newDraft: Consumables | undefined, submitType : SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<Consumables> = handleAxios.post("/api/consumable/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("消耗明细表保存成功")
            }).catch((error) => {
                messageApi.error("消耗明细保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存护理记录单
     * @param newDraft
     * @param submitType
     */
    async function saveNursingRecord(newDraft: NursingRecord | undefined, submitType : SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<NursingRecord> = handleAxios.post("/api/nursingRecord/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("护理记录单保存成功")
            }).catch((error) => {
                messageApi.error("护理记录单保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存或提交手术安全核查单
     * @param newDraft
     * @param submitType
     */
    async function saveSafetyCheckInfo(newDraft: SafetyCheckOfOperation | undefined, submitType: SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<SafetyCheckOfOperation> = handleAxios.post("/api/safetyCheck/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("手术安全核查单保存成功")
            }).catch((error) => {
                messageApi.error("手术安全核查单保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存或提交疤痕面诊单
     * @param newDraft
     * @param submitType
     */
    async function saveFaceDiagnosisInfo(newDraft: FaceDiagnosis | undefined, submitType: SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<FaceDiagnosis> = handleAxios.post("/api/faceDiagnosis/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("疤痕面诊单保存成功")
            }).catch((error) => {
                messageApi.error("疤痕面诊单保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存或提交手术知情同意书
     * @param newDraft
     * @param submitType
     */
    async function saveSurgicalInformedConsentInfo(newDraft: SurgicalInformedConsentForm | undefined, submitType: SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<SurgicalInformedConsentForm> = handleAxios.post("/api/surgicalInformedConsent/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("手术知情同意书保存成功")
            }).catch((error) => {
                messageApi.error("手术知情同意书保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存或提交疤痕术后注意事项
     * @param newDraft
     * @param submitType
     */
    async function savePostcautionForScarInfo(newDraft: PostPrecautionForScarSurgery | undefined, submitType: SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<PostPrecautionForScarSurgery> = handleAxios.post("/api/postPrecautionforscar/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("疤痕术后注意事项保存成功")
            }).catch((error) => {
                messageApi.error("疤痕术后注意事项保存失败:" + error.data);
            })
        }
    }

    /**
     * 保存或提交疤痕注射知情同意书
     * @param newDraft
     * @param submitType
     */
    async function saveScarInjectionInformedConsentInfo(newDraft: ScarInjectionInformedConsentForm | undefined, submitType: SUBMIT_TYPE) {
        if (newDraft === undefined) {
            return;
        } else {
            let ret:Promise<ScarInjectionInformedConsentForm> = handleAxios.post("/api/scarInjectionInformedConsent/submit", {
                ...newDraft,
                submitType: submitType
            })
            await ret.then(data => {
                messageApi.success("疤痕注射知情同意书保存成功")
            }).catch((error) => {
                messageApi.error("疤痕注射知情同意书保存失败:" + error.data);
            })
        }
    }

    /**
     * 根据病例号拉取一条消耗明细
     * @param baseInfo
     */
    async function getConsumableRecordByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<Consumables>> =
            handleAxios.get("/api/consumable/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取消耗明细表失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                consumableRecord.current = res.data;
            } else {
                consumableRecord.current = InitConsumablesRecord(baseInfo);
            }
        })
    }

    /**
     * 根据病例ID拉取疤痕面诊单
     * @param baseInfo
     */
    async function getFaceDiagnosisByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<FaceDiagnosis>> =
            handleAxios.get("/api/faceDiagnosis/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取疤痕面诊单失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                faceDiagnosisRecord.current = res.data;
            } else {
                faceDiagnosisRecord.current = InitFaceDiagnosis(baseInfo);
            }
        })
    }

    /**
     * 根据病例ID拉取手术知情同意书
     * @param baseInfo
     */
    async function getSurgicalInformedConsentByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<SurgicalInformedConsentForm>> =
            handleAxios.get("/api/surgicalInformedConsent/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取手术知情同意书失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                surgicalInformedConsentFormRecord.current = res.data;
            } else {
                surgicalInformedConsentFormRecord.current = InitSurgicalInformedConsentForm(baseInfo);
            }
        })
    }

    /**
     * 根据病例ID拉取疤痕术后注意事项
     * @param baseInfo
     */
    async function getPostcautionForScarByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<PostPrecautionForScarSurgery>> =
            handleAxios.get("/api/postPrecautionforscar/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取疤痕术后注意事项失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                postoperativePrecautionsForScarSurgeryRecord.current = res.data;
            } else {
                postoperativePrecautionsForScarSurgeryRecord.current = InitPostoperativePrecautions(baseInfo);
            }
        })
    }

    /**
     * 根据病例ID拉取疤痕注射知情同意书
     * @param baseInfo
     */
    async function getScarInjectionInformedConsentByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<ScarInjectionInformedConsentForm>> =
            handleAxios.get("/api/scarInjectionInformedConsent/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取疤痕注射知情同意书失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                scarInjectionInformedConsentFormRecord.current = res.data;
            } else {
                scarInjectionInformedConsentFormRecord.current = InitScarInjectionInformedConsentForm(baseInfo);
            }
        })
    }

    /**
     * 根据病例ID拉取护理记录单
     * @param baseInfo
     */
    async function getNursingRecordByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<NursingRecord>> =
            handleAxios.get("/api/nursingRecord/getByProfileId?profileId=" + baseInfo.profileId);
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取护理记录单失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                nursingRecord.current = res.data;
            } else {
                nursingRecord.current = {
                    ...InitNursingRecord(baseInfo),
                    operator: options!.operator[0],
                    firstAssistant: options!.firstAssistant[0],
                    secondAssistant: options!.firstAssistant[0],
                    rovingNurse: options!.rovingNurse[0],
                    handWashingNurse: options!.handWashingNurse[0]
                }
            }
        })
    }

    /**
     * 根据病例ID拉取手术安全核查表信息
     * @param profileId
     */
    async function getSafetyCheckByProfileId(baseInfo: AllBaseInfo) {
        let ret:Promise<BasicDataResponse<SafetyCheckOfOperation>> =
            handleAxios.get("/api/safetyCheck/getSafetyCheck?profileId=" + baseInfo.profileId)
        await ret.then((res) => {
            if (res.code !== 0) {
                messageApi.warning("拉取手术安全核查单失败" + res.data);
            } else if (res.code === 0 && res.data !== null) {
                    safetyCheckInfo.current = res.data;
            } else {
                // 没有查到手术安全核查表的使用初始值
                safetyCheckInfo.current = {
                    ...InitSafetyCheckOfOperation(baseInfo),
                    recordTime: "",
                    strategyName: options!.strategyName[0],
                    operator: options!.operator[0],
                    anestheticMode: options!.anestheticMode[0]
                }
            }
            // messageApi.info("安全核查表拉取成功")
        }).catch((error) => {
            console.log(error)
            messageApi.error("拉取安全核查表失败")
        })
    }



    /**
     * 初始化执行汉书
     */
    const initFunc = useMemo(() => {
        setLoading(true)
        listProfiles();
        getAllConfigs();
        setLoading(false)
        console.log("initFunc 初始化")
    }, [])

    /**
     * 下载手术记录单
     */
    /**
     * 下载手术记录单
     * @param record 护理记录单数据
     */
    function downLoadOperationRecord(record: NursingRecord) {
        if (record == undefined) {
            messageApi.warning("手术护理记录单为空")
        } else {
            if (record.steps == undefined) {
                messageApi.warning("手术步骤未选择");
            } else if (record.entryTime.entryTime === undefined) {
                messageApi.warning("入室时间未选择，无法生成门诊病历记录时间")
            } else if (record.entryTime.startTime === undefined) {
                messageApi.warning("手术开始时间未选择")
            } else if (record.entryTime.endTime === undefined) {
                messageApi.warning("手术结束时间未选择")
            } else if (record?.entryTime.recordTime === undefined) {
                messageApi.warning("记录时间未选择")
            } else {
                let startStr: string = record.entryTime.entryTime.substring(0, 11)
                    + record.entryTime.startTime;
                let endStr: string = record.entryTime.entryTime.substring(0, 11)
                    + record.entryTime.endTime;
                let recordStr : string = record?.entryTime.entryTime.substring(0, 11)
                    + record?.entryTime.recordTime;
                let downItem: TotalProfile = {
                    birthday: "",
                    ext: "",
                    gender: record.gender,
                    id: 0,
                    name: record.name,
                    profileId: record.profileId,
                    userId: "",
                    afterDiagnosis: record.beforeDiagnosis,
                    age: record.age,
                    anesthesiologist: record.anesthesiologist,
                    anestheticMode: record.anestheticMode,
                    beforeDiagnosis: record.beforeDiagnosis,
                    endTime: endStr,
                    firstAssistant: record.firstAssistant,
                    handWashingNurse: record.handWashingNurse,
                    operator: record.operator,
                    recordTime: recordStr,
                    rovingNurse: record.rovingNurse,
                    startTime: startStr,
                    steps: record.steps,
                    strategyName: record.strategyName
                }
                fileDownLoad(downItem)
            }
        }
    }

    const submitModify = async () => {
        // 校验各个必须的字段是否都有值
        let checkRes = CheckAllBaseInfo(editing!);
        // 校验结果为空，那么可以直接提交
        if (checkRes !== "") {
            messageApi.open({
                type: "error",
                content:checkRes
            })
        } else {
            try {
                await UpdateOneBaseInfo(editing!)
                setEditing(undefined);
                await listProfiles();
                messageApi.success("修改成功")
            } catch (e) {
                messageApi.error("新增病人信息失败")
            }
        }
    }

    return (
        <>
            {contextHolder}
            {editing !== undefined && (
                <Modal
                    key={editing?.id}
                    title={'更新病人基础信息'}
                    width={'40vw'}
                    open={editing !== undefined}
                    onCancel={() => setEditing(undefined)}
                    onOk={() => {
                        submitModify();
                        listProfiles();
                    }
                    }
                >
                    <BaseInfoEditor
                        initValue={editing}
                        onChange={v => {
                            setEditing(v);
                            // console.log("upload file output:", v);
                        }}
                    />
                </Modal>
            )}
            <Card
                style={{
                    marginTop: "20px"
                }}
            >
                <Row justify="start" align="middle">
                    <Col span={2}>
                        病案号
                    </Col>
                    <Col span={3}>
                        <Input
                            onChange={(e) => {
                                if (e.target.value === "") {
                                    setListConditions({...listConditions, profileId: undefined})
                                } else {
                                    setListConditions({...listConditions, profileId: e.target.value})
                                }
                            }}
                            onPressEnter={handleSearch}
                        />
                    </Col>
                    <Col span={2}>
                        姓名
                    </Col>
                    <Col span={3}>
                        <Input
                            onChange={(e) => {
                                if (e.target.value === "") {
                                    setListConditions({...listConditions, name:undefined})
                                } else {
                                    setListConditions({...listConditions, name: e.target.value})
                                }
                            }}
                            onPressEnter={handleSearch}
                        />
                    </Col>
                    <Col span={2}>
                        性别
                    </Col>
                    <Col span={3}>
                        <Input
                            onChange={(e) => {
                                if (e.target.value === "") {
                                    setListConditions({...listConditions, gender: undefined})
                                } else {
                                    setListConditions({...listConditions, gender: e.target.value})
                                }
                            }}
                            onPressEnter={handleSearch}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            icon={<SearchOutlined />}
                            type="primary"
                            onClick={handleSearch}
                        >
                            查询
                        </Button>
                    </Col>
                </Row>
            </Card>
            <Table
                rowKey="id"
                style={{width: "100%", marginTop: "20px"}}
                columns={tableHeader}
                dataSource={listResponse?.data || []}
                loading={loading}
                pagination={{
                    showSizeChanger: true,
                    total: listResponse?.total,
                    showTotal: (totalNum, _) => `共 ${totalNum } 条`,
                    onChange: (page, pageSize) => {
                        listConditions.limit = pageSize;
                        listConditions.offset = (page - 1) * pageSize;
                        clearUseRefAndFresh();
                        listProfiles();
                    }
                }}
            />
            {!loading
            && !!options
            && timeStamp
            && currentBaseInfo !== undefined
            && nursingRecord.current !== undefined
            && safetyCheckInfo.current !== undefined
            && consumableRecord.current !== undefined
                && postoperativePrecautionsForScarSurgeryRecord.current !== undefined // 疤痕手术术后注意事项
                && scarInjectionInformedConsentFormRecord.current !== undefined // 疤痕注射知情同意书
                && faceDiagnosisRecord.current !== undefined // 疤痕面诊单
                && surgicalInformedConsentFormRecord.current !== undefined // 手术知情同意书
            && (
                <>
                    <Card
                        key={String(timeStamp)} // 控制页面强制刷新
                        style={{marginTop: '10px', marginBottom: '40px'}}
                    >
                        <Tabs
                            defaultActiveKey={currentActiveKey}
                            onChange={(activeKey) => {
                                setCurrentActiveKey(activeKey)
                            }}
                            tabBarExtraContent={
                            <>
                            <Divider type={"vertical"} />
                            <Button
                                type="primary"
                                style={{marginLeft: "10px"}}
                                onClick={() => {
                                    saveAllDraft()
                                }}
                            >
                                保存所有草稿
                            </Button>
                        </>}
                        items={[
                            {
                                label:"手术安全核查表",
                                key:"0",
                                children:
                                    <SafetyCheck
                                        options={options}
                                        defaultValue={safetyCheckInfo.current}
                                        fatherChange={(newValue) => {
                                            safetyCheckInfo.current = newValue
                                            // console.log(newValue)
                                        }}
                                        saveDraft={saveSafetyCheckInfo}
                                    />
                            },
                            {
                                label:"手术护理记录单",
                                key:"1",
                                children: <NursingRecordOfOperation
                                    defaultValue={nursingRecord.current}
                                    onChange={v => {
                                        nursingRecord.current = v;
                                    }}
                                    options={options}
                                    saveDraft={saveNursingRecord}
                                    downloadOperationRecord={downLoadOperationRecord}
                                />
                            },
                            {
                                label:"所用材料明细表",
                                key:"2",
                                children: <Consumable
                                    defaultValue={consumableRecord.current}
                                    options={options}
                                    onChange={consumableOnChange}
                                    saveDraft={() =>{
                                        if (consumableRecord.current === undefined) {
                                            messageApi.warning("所用材料明细为空")
                                        } else {
                                            saveConsumableRecord(consumableRecord.current, SUBMIT_TYPE.TYPE_SAVE_DRAFT)
                                        }
                                    }}
                                />
                            },
                            {
                                label: "疤痕面诊单",
                                key: "3",
                                children: <FaceDiagnosisPage
                                    defaultValue={faceDiagnosisRecord.current!}
                                    newValue={faceDiagnosisRecord.current}
                                    fatherChange={(newValue) => {
                                        faceDiagnosisRecord.current = newValue
                                        console.log("newValue", newValue)
                                    }}
                                    saveDraft={saveFaceDiagnosisInfo}
                                />
                            },
                            {
                                label: "疤痕术后注意事项",
                                key: "4",
                                children: <PostoperativePrecautionsForScarSurgeryPage
                                    defaultValue={postoperativePrecautionsForScarSurgeryRecord.current!}
                                    newValue={postoperativePrecautionsForScarSurgeryRecord.current}
                                    fatherChange={(newValue) => {
                                        console.log("postPrecautionForScarSurgery newValue:", newValue);
                                        postoperativePrecautionsForScarSurgeryRecord.current = newValue;
                                    }}
                                    saveDraft={savePostcautionForScarInfo}
                                />
                            },
                            {
                                label: "手术知情同意书",
                                key: "5",
                                children: <SurgicalInformedConsentPage
                                    defaultValue={surgicalInformedConsentFormRecord.current!}
                                        newValue={surgicalInformedConsentFormRecord.current}
                                    fatherChange={(newValue) => {
                                        console.log("newValue:", newValue);
                                        surgicalInformedConsentFormRecord.current = newValue; // 赋值
                                    }}
                                    saveDraft={saveSurgicalInformedConsentInfo}
                                />
                            },
                            {
                                label: "疤痕注射知情同意书",
                                key: "6",
                                children: <ScarInjectionInformedConsentPage
                                    defaultValue={scarInjectionInformedConsentFormRecord.current!}
                                    newValue={scarInjectionInformedConsentFormRecord.current}
                                    fatherChange={(newValue) => {
                                        console.log("scarInjectionIformedConsent newValue:", newValue);
                                        scarInjectionInformedConsentFormRecord.current = newValue;
                                    }}
                                    saveDraft={saveScarInjectionInformedConsentInfo}
                                />
                            }
                        ]}/>
                    </Card>
                </>
                )
            }
        </>)
}